import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './WordsPerMinuteInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const WordsPerMinuteInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ wpm, setWpm ] = useState<number>(project.encoder.aggregatorWordsPerMinute);
  const debounce = 100;
  const min = 120;
  const max = 350;

  const onAfterChange = (data: string) => {
    if (project.encoder) {
      let value = wpm;

      if (wpm < min) {
        value = min;
      } else if (wpm > max) {
        value = max;
      }

      setWpm(value);

      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          aggregatorWordsPerMinute: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          aggregatorWordsPerMinute: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setWpm(project.encoder.aggregatorWordsPerMinute);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.aggregatorWordsPerMinute]);

  return (
    <div className="words-per-minute-input">
      <div className="input-title">
        {t('producer.inputs.words-per-minute.title')}
        <Help
          title="Words Per Minute"
          text="Words Per Minute (WPM) sets the maximum reading speed for captions.<br/><br/>- Lower WPM values slow down caption display, making it easier for viewers to read.<br/>- Higher WPM values allow more text to appear quickly but may be difficult to follow for some viewers.<br/>- Adjust this setting based on your audience’s reading speed and the complexity of your content.<br/><br/>Properly setting WPM helps ensure captions are readable and keep pace with the audio."
        />
      </div>
      <TextInput
        placeholder="producer.inputs.words-per-minute.placeholder"
        value={wpm.toString()}
        onChange={(value) => {setWpm(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">{t('producer.inputs.words-per-minute.footer')}</div>
    </div>
  );
};

export default React.memo(WordsPerMinuteInput);
